import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import type { IAuthValidateFormValues, IAuthValidateModel, IAuthValidateSubmitResult } from '@/types/security/auth-validate';

const AUTH_VALIDATE_ENDPOINT = '/api/register/auth-validate';

const defaultAuthValidateModel: IAuthValidateModel = {
    token: '',
    languageData: {},
};

interface IAuthValidateResults {
    registrationId: number;
    editKey: string;
}

export const useAuthValidate = (token: string) => {
    const url = `${AUTH_VALIDATE_ENDPOINT}/${token}`;

    const { model, isLoading, error } = useApiModel(url, defaultAuthValidateModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IAuthValidateFormValues, IAuthValidateResults, IAuthValidateSubmitResult>(
        url,
        (values) => ({ code: values.code }),
        ({ registrationId, editKey }) => ({ registrationId, editKey }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
